import {
  AnyAction,
  CombinedState,
  ThunkDispatch,
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { userSlice } from 'api/slices/userSlice';
import { Dispatch } from 'react';
import { approverSlice } from 'api/slices/approversSlice';

const appReducer = combineReducers({
  userInfo: userSlice.reducer,
  approversList: approverSlice.reducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (
  state: RootState | undefined,
  action: AnyAction
): CombinedState<{ userInfo; approversList }> => {
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): ThunkDispatch<
  CombinedState<{ userInfo; approversList }>,
  undefined,
  AnyAction
> &
  Dispatch<AnyAction> => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
